import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/for-artists/")({
  beforeLoad: () => {
    throw redirect({ to: "/artists", replace: true });
  },
});
